import _curry2 from "./_curry2.js";
import _flatCat from "./_flatCat.js";
import map from "../map.js";

var _xchain =
/*#__PURE__*/
_curry2(function _xchain(f, xf) {
  return map(f, _flatCat(xf));
});

export default _xchain;


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_xchain.js
// module id = 1774
// module chunks = 1